export const groups = {
	groups: [
		{ translated: 'Audio', name: 'audio' },
		{ translated: 'Communication', name: 'communication' },
		{ translated: 'Company', name: 'company' },
		{ translated: 'Finance', name: 'finance' },
		{ translated: 'Geographical', name: 'geographic' },
		{ translated: 'Image', name: 'image' },
		{ translated: 'Internet', name: 'internet' },
		{ translated: 'Personal', name: 'personal' },
		{ translated: 'Product', name: 'product' },
		{ translated: 'Security', name: 'security' },
		{ translated: 'Text', name: 'text' },
	],
};
